import React, { memo } from 'react'
import { VaccinationForm } from 'src/components/client/vaccination-form/VaccinationForm'

const VaccinationPageComponent = () => {
  return <VaccinationForm />
}

export const VaccinationPage = memo(VaccinationPageComponent)
